<div>
    <br>
    <br>
    <p-select ngDefaultControl [(ngModel)]="selectedCategory" [options]="iconCategories" optionLabel="title"
        [placeholder]="'icon_category'| translation" appendTo="body"/>
    <p-select *ngIf="!selectedCategory" [disabled]="!selectedCategory" [placeholder]="'icon'| translation"
        appendTo="body" [virtualScroll]="true" virtualScrollItemSize="20" />

    <p-select *ngIf="selectedCategory" [(ngModel)]="selectedIcon" [options]="selectedCategory?.items"
        [placeholder]="'icon'| translation" appendTo="body" [virtualScroll]="true" virtualScrollItemSize="20">
        <ng-template #selectedItem let-selectedOption>
            <span *ngIf="selectedOption" [innerHTML]="getIconHtml(selectedIcon)"></span>
        </ng-template>

        <ng-template let-icon #item>
            <i [ngClass]="icon"></i>
        </ng-template>
    </p-select>

    <div class="form-field">
        <input pInputText [placeholder]="'category_new'| translation" noWhiteSpace #newCatName="ngModel"
            [(ngModel)]="newCat" (input)="previewCat()">
    </div>

</div>
<div style="color:red;" *ngIf="alreadyExists()">{{'model_already_exist'| translation}}.</div>
<div style="color:red;" *ngIf="newCatName.errors && newCatName.errors.noWhiteSpace">{{'model_no_white_space'|
    translation}}.
</div>


<div *ngIf="newCat && selectedIcon" class="row">
    <br>
    <span>{{'menu_preview'| translation}}:</span>
    <br>
    <div class="col-md-3">
        <p-panelmenu [model]="previewList" status="primary"></p-panelmenu>
    </div>
    <br>
    <div>
        <button pButton severity="primary" (click)="createCategory()"
            [disabled]="alreadyExists() || newCatName.invalid">{{'add'| translation}}</button>
    </div>
</div>